/**
 * URL helpers: every page URL on the site ends with "/".
 * Shared by components, JSON-LD, prerender and sitemap generation.
 */

import { siteConfig } from '../config';

const SITE_ORIGIN = siteConfig.siteUrl.replace(/\/+$/, '');
const FILE_EXTENSION = /\/[^/]*\.[a-z0-9]{1,8}$/i;

/**
 * Normalize an internal path so it always ends with "/".
 * Paths pointing to files (.xml, .txt, .png...) or carrying a query string / hash are left untouched.
 * @example withTrailingSlash('retro-drift') // '/retro-drift/'
 */
export function withTrailingSlash(path = '/'): string {
  const splitAt = path.search(/[?#]/);
  const pathname = splitAt === -1 ? path : path.slice(0, splitAt);
  const suffix = splitAt === -1 ? '' : path.slice(splitAt);
  const normalized = `/${pathname}`.replace(/\/{2,}/g, '/');

  if (suffix || normalized.endsWith('/') || FILE_EXTENSION.test(normalized)) {
    return normalized + suffix;
  }
  return `${normalized}/`;
}

/**
 * Build the absolute canonical URL for a path (or an absolute URL on any origin).
 * @example buildCanonical('/retro-drift') // 'https://cookieclickeronline.io/retro-drift/'
 * @example buildCanonical('/') // 'https://cookieclickeronline.io/'
 */
export function buildCanonical(path = '/'): string {
  if (/^https?:\/\//i.test(path)) {
    const url = new URL(path);
    return `${url.origin}${withTrailingSlash(`${url.pathname}${url.search}${url.hash}`)}`;
  }
  return `${SITE_ORIGIN}${withTrailingSlash(path)}`;
}
